import type { RoomConfig } from '@tctp/protocol';
import { useState } from 'react';
import type { SoundLevel } from '../sound';

export const SOUND_LABEL: Record<SoundLevel, string> = { 0: 'off', 1: 'small', 2: 'medium', 3: 'large' };

/** `canPause` is false while the board is still being dealt (an all-in run-out): PAUSE waits for the hand to finish. */
export function TopRightInfo({ hostNickname, config, isHost, running, paused, canPause = true, endRequested = false, sound, onToggleSound, onPause, onResume, onEnd }: {
  hostNickname: string | null; config: RoomConfig; isHost: boolean; running: boolean; paused: boolean; canPause?: boolean; endRequested?: boolean; sound: SoundLevel;   // `endRequested`: END was pressed during a hand, so the table finishes it first
  onToggleSound: () => void; onPause: () => void; onResume: () => void; onEnd: () => void;
}) {
  const [confirmEnd, setConfirmEnd] = useState(false);
  return (
    <>
      <div className="info">
        <div className="info-owner">OWNER: {hostNickname ?? '—'}</div>
        <div className="info-blinds">PINEAPPLE ~ {config.smallBlind} / {config.bigBlind}</div>
      </div>
      <div className="info-buttons">
        <button type="button" className="icon-btn" aria-label={`Sound ${SOUND_LABEL[sound]}`} title="Sound: off, small, medium, large" onClick={onToggleSound}>
          <svg className={`snd${sound === 0 ? ' off' : ''}`} viewBox="0 0 26 24" aria-hidden="true">
            <path d="M2 9v6h4l5 4.5v-15L6 9H2z" fill="currentColor" />
            {sound >= 1 && <path d="M14 9.5a3.5 3.5 0 0 1 0 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" fill="none" />}
            {sound >= 2 && <path d="M17 7a7 7 0 0 1 0 10" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" fill="none" />}
            {sound >= 3 && <path d="M20 4.5a10.5 10.5 0 0 1 0 15" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" fill="none" />}
          </svg>
        </button>
        {isHost && running && (paused
          ? <button type="button" className="icon-btn" onClick={onResume}><span className="hint" aria-hidden="true">P</span>▶<small>RESUME</small></button>
          : <button type="button" className="icon-btn" onClick={onPause} disabled={!canPause} title={canPause ? undefined : 'Pause once the board is dealt'}><span className="hint" aria-hidden="true">P</span>❚❚<small>PAUSE</small></button>)}
        {isHost && running && endRequested && <span className="ends-after" role="status">Ends after this hand</span>}
        {isHost && running && !endRequested && !confirmEnd && <button type="button" className="icon-btn" onClick={() => setConfirmEnd(true)}>■<small>END</small></button>}
        {isHost && running && confirmEnd && (
          <div className="confirm-end">
            <button type="button" className="btn red" onClick={() => { setConfirmEnd(false); onEnd(); }}>CONFIRM END</button>
            <button type="button" className="btn grey" onClick={() => setConfirmEnd(false)}>KEEP PLAYING</button>
          </div>
        )}
      </div>
    </>
  );
}
